import Butter from 'buttercms';
export const butter = Butter('5362ab37da83ec320a5f2adac3203631b725dc8e');
